import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Typography,
  Paper,
  Button,
  Grid,
  Chip,
  Avatar,
  Modal,
  Divider,
  alpha,
  useTheme,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Sidebar from "../sideBar";
import { allApprovedRequests } from "../../../state/slices/admin";

import { useSelector, useDispatch } from "react-redux";
import { GridOverlay } from "@mui/x-data-grid";
import { useTheme as useMuiTheme } from "@mui/material/styles";
import Loading from "../../../components/loading/loading";
import RequestDetailPage from "../RequestDetailPage";

const ApprovedRequestPage = () => {
  const theme = useMuiTheme();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const dispatch = useDispatch();
  const {approvedRequests,loading} = useSelector((state) => state.admin);
  useEffect(() => {
    dispatch(allApprovedRequests());
  }, [dispatch]);

  const columns = [
    { field: "studentName", headerName: t('dashboard.studentName'), width: 150 },
    { field: "tutorName", headerName: t('dashboard.tutorName'), width: 150 },
    { field: "studentPhone", headerName: t('dashboard.studentPhone'), width: 150 },
    { field: "tutorPhone", headerName: t('dashboard.tutorPhone'), width: 150 },
    { field: "studentEmail", headerName: t('dashboard.studentEmail'), width: 200 },
    { field: "tutorEmail", headerName: t('dashboard.tutorEmail'), width: 200 },
    { field: "startingTime", headerName: t('dashboard.startingTime'), width: 150 },
    { field: "message", headerName: t('dashboard.message'), width: 200 },
    { field: "tutorRate", headerName: t('dashboard.tutorRate'), width: 150 },
    { field: "tutoringType", headerName: t('dashboard.tutoringType'), width: 150 },
    { field: "adminStatus", headerName: t('dashboard.adminStatus'), width: 120 },
    { field: "tutorStatus", headerName: t('dashboard.tutorStatus'), width: 120 },
  ];

  const rows = approvedRequests.map((request) => ({
    id: request._id,
    studentName: `${request.studentId.userId.firstName} ${request.studentId.userId.lastName}`,
    tutorName: `${request.tutorId.userId.firstName} ${request.tutorId.userId.lastName}`,
    studentPhone: request.studentId.userId.phoneNumber,
    tutorPhone: request.tutorId.userId.phoneNumber,
    studentEmail: request.studentId.userId.email,
    tutorEmail: request.tutorId.userId.email,
    startingTime: request.startingTime,
    message: request.message,
    tutorRate: request.tutorId.rate,
    tutoringType: request.tutoringType,
    adminStatus: request.adminApproved,
    tutorStatus: request.status,
  }));

  

  const CustomNoRowsOverlay = () => (
    <GridOverlay>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          color: "secondary",
        }}
      >
        <Typography variant="h6">{t('dashboard.noApprovedRequests')}</Typography>
      </Box>
    </GridOverlay>
  );

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: alpha(theme.palette.primary.main, 0.03) }}>
      <Grid container>
        <Grid item xs={12} md={2}>
          <Sidebar />
        </Grid>
        <Grid item xs={12} md={10}>
          <Box sx={{ p: { xs: 2, md: 4 } }}>
            <Typography 
              variant="h4" 
              sx={{ 
                fontWeight: 700, 
                color: theme.palette.primary.main, 
                mb: 3 
              }}
            >
              {t('dashboard.requestDetails')} - {t('request.approved')}
            </Typography>
            <Paper 
              elevation={0}
              sx={{ 
                p: 3,
                borderRadius: 3,
                boxShadow: `0 4px 20px ${alpha(theme.palette.primary.main, 0.1)}`,
                border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
              }}
            >
              <div style={{ height: 600, width: "100%" }}>
                {loading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <Loading />
                  </Box>
                ) : (
                  <DataGrid
                    columns={columns}
                    rows={rows}
                    columnHeaderHeight={60}
                    onCellClick={(e) => {
                      const request = approvedRequests.find(
                        (request) => request._id === e.row.id
                      );
                      setSelectedRequest(request);
                      handleOpen();
                    }}
                    components={{
                      NoRowsOverlay: CustomNoRowsOverlay,
                    }}
                    sx={{
                      '& .MuiDataGrid-cell:hover': {
                        cursor: 'pointer',
                      },
                      '& .MuiDataGrid-row:hover': {
                        bgcolor: alpha(theme.palette.primary.main, 0.05),
                      }
                    }}
                  />
                )}
              </div>
            </Paper>
          </Box>
        </Grid>
        {selectedRequest && <RequestDetailPage open={open} handleClose={handleClose} data={approvedRequests.find((request) => request._id === selectedRequest._id)} />}
      </Grid>
    </Box>
  );
};

export default ApprovedRequestPage;
